import React from 'react';
import { withStyles } from '@material-ui/core';
import { SaveAltSharp, Close as CloseIcon } from '@material-ui/icons';
import SearchBox from '../../../../../common/SearchBox';
import Tooltip from '../../../../../common/StyledToolTip';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  moduleHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: 'bold',
    fontSize: theme.headerTextFontSize,
    padding: '2px 10px 8px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  gridActionIcons: {
    display: 'flex',
    alignItems: 'center',
    float: 'right',
  },
  headerIconStyles: {
    padding: '5px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    color: theme.iconColor
  }
});

const Header = ({ classes, exportCSV, title, updateQuickFilterText, onCloseModel, kpiName, gridApi }) => {
  return (
    <header className={classes.moduleHeader}>
      <span>{title}</span>
      <div className={classes.gridActionIcons}>
        <SearchBox onChange={updateQuickFilterText} />
        <ClearAllFilterButton gridApi={gridApi} />
        <span onClick={exportCSV} className={classes.headerIconStyles}>
          <Tooltip title="Export Data">
            <SaveAltSharp />
          </Tooltip>
        </span>
        <span onClick={() => onCloseModel(kpiName)} className={classes.headerIconStyles}>
          <Tooltip title="Close">
            <CloseIcon />
          </Tooltip>
        </span>
      </div>
    </header>
  );
};

export default withStyles(styles)(Header);
